/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { arrayOf, func, shape, string } from 'prop-types';
import * as R from 'ramda';
import { Box, Divider, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CheckBoxRoundedIcon from '@mui/icons-material/CheckBoxRounded';

// Utils
import { totalProgress } from 'feature/loading-management/utils/calculate';

// Components
import IndividualProgressIndicator from '../../../create-new-common/IndividualProgressIndicator';
import SubmitProgressHeader from '../../../create-new-common/SubmitProgressHeader';

// Styles
import { checkboxIconStyles, headerStyles, productStyles } from '../Steps.styles';

const SummaryStep = props => {
  const {
    authorizationBy,
    createNewCarrierAuth,
    setSubmittingBatch,
    enabledOptions,
    refreshCarrierAuthorizationsListView,
    viewBySelection,
  } = props;
  const theme = useTheme();
  const isMounted = useRef(true);

  const [productProgress, setProductProgress] = useState([]);

  const total = totalProgress(productProgress, enabledOptions);

  useEffect(() => {
    setSubmittingBatch(true);

    // prevent updating state when unmounted
    const updateState = result => {
      if (isMounted.current) {
        setProductProgress(R.append(result));
      }
    };
    const id = authorizationBy === 'carrier' ? 'locationId' : 'carrierId';

    R.forEach(
      R.compose(R.andThen(updateState), createNewCarrierAuth, R.objOf(id), R.prop('value')),
      enabledOptions
    );

    return () => {
      isMounted.current = false;
    };
  }, [authorizationBy, createNewCarrierAuth, enabledOptions, setProductProgress]);

  useEffect(() => {
    if (total === 100) {
      setSubmittingBatch(false);
      refreshCarrierAuthorizationsListView();
    }
  }, [refreshCarrierAuthorizationsListView, setSubmittingBatch, total]);

  return (
    <>
      <Box bgcolor="graphic.lighter" color="primary.dark" pb={3} pt={2} px={2} width="100%">
        <Typography color="inherit" sx={{ root: headerStyles(theme) }} variant="body1">
          Setting Up Carrier Options{' '}
          {authorizationBy === 'carrier'
            ? `for ${viewBySelection.carrierName}`
            : `at ${viewBySelection.nameShort}`}
        </Typography>
        <SubmitProgressHeader totalProgress={total} />
      </Box>

      <Divider />

      {R.map(({ label, value }) => {
        const item = R.find(R.propEq('id', value), productProgress);

        return (
          <Box key={value} sx={productStyles(theme)}>
            <CheckBoxRoundedIcon color="inherit" sx={checkboxIconStyles(theme)} />
            <Typography color="textPrimary" variant="body1">
              {label}
            </Typography>
            <IndividualProgressIndicator
              error={item?.error.title ?? ''}
              isSuccessful={item?.success ?? false}
            />
          </Box>
        );
      }, enabledOptions)}
    </>
  );
};

SummaryStep.propTypes = {
  authorizationBy: string.isRequired,
  createNewCarrierAuth: func.isRequired,
  enabledOptions: arrayOf(shape).isRequired,
  refreshCarrierAuthorizationsListView: func.isRequired,
  setSubmittingBatch: func.isRequired,
  viewBySelection: shape({}).isRequired,
};

export default SummaryStep;
